import axios from 'axios'
import apiConfig from '../../config/apiConfig'
import * as types from './actionType'

export function getDeviceStatus(storeIds) {
  return async function (dispatch) {
    await axios
      .get(`${apiConfig.api.url}/device_statuses?location_ids=/${storeIds}`)
      .then((resp) => {
        if (resp.headers.message === 'Success') {
          dispatch({
            type: types.GET_DEVICE_LIST,
            payload: resp.data,
          })
        } else {
          dispatch({
            type: types.GET_DEVICE_LIST,
            payload: resp.headers.message,
          })
        }
      })
      .catch(() => {
        dispatch({
          type: types.GET_DEVICE_LIST,
          payload: 'Please enter valid store number(s)!',
        })
      })
  }
}

export function getImagesoundPlayers() {
  return async function (dispatch) {
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    await axios
      .get(`${apiConfig.api.url}/imagesound_players`)
      .then((resp) => {
        let playersList = resp.data
        if (playersList.length === 0) {
          playersList = 'No Imagesound Players Found!'
        }
        dispatch({
          type: types.GET_IMAGESOUND_PLAYERS,
          payload: playersList,
        })
      })
      .catch((error) => {
        var result = 'No Imagesound Players Found!'
        dispatch({
          type: types.GET_IMAGESOUND_PLAYERS,
          payload: result,
        })
      })
  }
}
